import UIFetchService from '../Service/UIFetchService';
import { isEmpty, isNotEmpty, parseUrlSearch } from '../Service/Utils'

import ReactJson from 'react-json-view';
import React from 'react';
import {
    Layout, Row, Col, Anchor, Tag, Space, Divider
} from 'antd';
import {
    BankOutlined
} from '@ant-design/icons';



const methodColors = {
    GET: '#1890ff',
    PUT: '#faad14',
    POST: '#a0d911',
    DELETE: '#f5222d',
    PATCH: '#722ed1'
}

const methodBgColors = {
    GET: '#D3EEF9',
    PUT: '#fff1b8',
    POST: '#d9f7be',
    DELETE: '#ffccc7',
    PATCH: '#efdbff'
}

class ApiDocsView extends React.Component {
    constructor() {
        super();
        this.state = {
            apis: []
        };
    }


    render() {
        return <div style={{ margin: '10px 40px' }}>
            <Layout>
                <Layout.Sider theme='light'>
                    <Row>
                        <Col>
                            <Anchor>
                                <Anchor.Link href="#API" title="APIs">
                                    {/* <Anchor.Link href="#api1" title="获取标签属性" />
                                    <Anchor.Link href="#Link-Props" title="Link Props" /> */
                                        this.state.apis.map(api => <Anchor.Link href={`#api-${api.id}`} title={api.name} />)}

                                </Anchor.Link>
                            </Anchor>

                        </Col>
                    </Row>
                </Layout.Sider>
                <Layout.Content id='API'>
                    {this.state.apis.map(api => <>
                        <Row>
                            <Col flex='100%' id={`api-${api.id}`}>
                                <h2>{api.name}</h2>
                            </Col>
                        </Row>
                        <Row style={{margin: '0 0 10px 0'}}>
                            <Col>
                                <span style={{ fontSize: 15, color: 'gray' }}>{api.comment}</span>
                            </Col>
                        </Row>
                        <Row style={{margin: '0 0 10px 0'}}>
                            <Space>
                                <Col>服务地址：</Col>
                                {isNotEmpty(api.prdHost) && <Col><Tag color='#52c41a'>生产环境</Tag><code>{api.prdHost}</code></Col>}
                                {isNotEmpty(api.devHost) && <Col><Tag color='#8c8c8c'>测试环境</Tag><code>{api.devHost}</code></Col>}
                            </Space>
                        </Row>
                        <Row style={{margin: '0 0 10px 0'}}>
                            <Col>
                                <span>签权方法：{api.authDesc}</span>
                            </Col>
                        </Row>
                        {api.methods.map(method => <div style={{
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: methodColors[method.method],
                            margin: '0 0 10px 0'
                        }}>
                            <Row
                                style={{
                                    fontSize: 15,
                                    padding: '10px',
                                    width: '100%',
                                    backgroundColor: methodBgColors[method.method],
                                }}>
                                <Space>
                                    <Col>
                                        <Tag
                                            color={methodColors[method.method]}>{method.method}</Tag>
                                    </Col>
                                    <Col>
                                        <code style={{ fontWeight: 'bold' }}>{method.path}</code>
                                    </Col>
                                    <Col>
                                        <span>{method.name}</span>
                                    </Col>
                                </Space>
                            </Row>
                            <Row
                                style={{
                                    padding: '10px',
                                    backgroundColor: '#f0f0f0',
                                    borderWidth: '1px 0 0 0',
                                    borderStyle: 'solid',
                                    borderColor: methodColors[method.method]
                                }}
                            >
                                <Col flex='100%'>
                                    <span style={{ fontWeight: 'bold' }}>参数</span>
                                </Col>
                            </Row>
                            <Row
                                style={{
                                    padding: '10px',
                                    backgroundColor: methodBgColors[method.method],
                                    borderWidth: '1px 0 0 0',
                                    borderStyle: 'solid',
                                    borderColor: methodColors[method.method]
                                }}
                            >

                                <Col flex='100%'>
                                    <Row>
                                        <Col flex='200px'>
                                            <span>参数名</span>
                                        </Col>
                                        <Col flex='100px'>
                                            <span>种类</span>
                                        </Col>
                                        <Col flex='100px'>
                                            <span>数据类型</span>
                                        </Col>
                                        <Col flex='200px'>
                                            <span>示例</span>
                                        </Col>
                                        <Col flex='auto'>
                                            <span>说明</span>
                                        </Col>
                                    </Row>
                                    {method.params.map(param => <Row>
                                        <Col flex='200px'>
                                            <code>{param.name}</code></Col>
                                        <Col flex='100px'>{param.kind}</Col>
                                        <Col flex='100px'>
                                            <code>{param.type}</code>
                                        </Col>
                                        <Col flex='200px'>
                                            <code>{param.allowValues}</code>
                                        </Col>
                                        <Col flex='auto'>
                                            <span style={{ color: 'gray' }}>{param.comment}</span>
                                        </Col>
                                    </Row>)}
                                </Col>
                            </Row>
                            <Row
                                style={{
                                    padding: '10px',
                                    backgroundColor: '#f0f0f0',
                                    borderWidth: '1px 0 0 0',
                                    borderStyle: 'solid',
                                    borderColor: methodColors[method.method]
                                }}
                            >
                                <Col flex='100%'>
                                    <span style={{ fontWeight: 'bold' }}>Response</span>
                                </Col>
                            </Row>
                            <Row
                                style={{
                                    padding: '10px',
                                    backgroundColor: methodBgColors[method.method],
                                    borderWidth: '1px 0 0 0',
                                    borderStyle: 'solid',
                                    borderColor: methodColors[method.method]
                                }}
                            >
                                <Col flex='100%'>
                                    <Row>
                                        <Col flex='200px'>
                                            <span>Code</span>
                                        </Col>
                                        <Col flex='auto'>
                                            <span>描述</span>
                                        </Col>
                                    </Row>
                                    {[200, 401, 403, 500].map(code => <>
                                        <Row>
                                            <Col flex='200px'>
                                                <code>{code}</code>
                                            </Col>
                                            <Col flex='auto'>
                                                <span>{method[`code${code}Desc`]}</span>
                                            </Col>
                                        </Row>
                                        {code === 200 && <Row>
                                            <Col flex='200px'></Col>
                                            <Col flex='auto'>
                                                <ReactJson
                                                    indentWidth={4}
                                                    collapsed={true}
                                                    src={JSON.parse(method.responseDecl)}
                                                />
                                            </Col>
                                        </Row>}
                                    </>)}
                                </Col>
                            </Row>
                            
                        </div>)}
                        <Divider />
                    </>)}
                </Layout.Content>
            </Layout>
        </div>;
    }

    async componentDidMount() {
        const apis = await UIFetchService.get('/api/v1/api_docs/apis');
        this.setState({ apis });
    }
}

export default ApiDocsView;